/// <reference path="../_all.ts" />

module editor {
  'use strict';

  export enum ContentMetaStatus {
    Draft = 1,
    Published = 2,
    Archived = 3,
    Deleted = 4,
  }

  
  export enum ContentAttachementType {
    ContentImage = 1,
    ContentAttachment = 2,
  }

  export class ContentMeta {
    constructor(
      public Id: number,
      public Title: string,
      public URL: string,
      public Image: string,
      public Tags: ContentTag[],
      public Attachment: string,
      public IsFeatured: boolean,
      public Status: ContentMetaStatus,
      public IsVisible: boolean,
      public MetaTitle: string,
      public MetaDescription: string,
      public Permission: string,
      public ValidFrom: Date,
      public ValidTo: Date,
      public CreatedAt: Date,
      public ModifiedAt: Date,
      public CreatedBy?: string, // erweitern
      public ModifiedBy?: string, // erweitern
      public PublishedAt?: Date,
      public PublishedBy?: string, // erweitern
      public LastAuthor?: string,
      public RoutedURL?: string,
      public RowVersion?:string, //base64 encoded byte array of row version
    ) { }
  }
}